import "./Downloads.css";

import phoneMockup from "../../assets/optimiz-app-mockup.png";
import googlePlayLogo from "../../assets/google-play-logo.svg";
import appleLogo from "../../assets/apple-logo.svg";

const Downloads = () => {
  return (
    <section className="download-section-main">
      <div className="download-section">
        <div className="download-text-content">
          <h1>Download the Optimiz app</h1>
          <p>
            Empower your team and streamline operations with the Optimiz app.
            Manage everything on the go, from employee tracking to dealer
            orders, all in one place.
          </p>
          <div className="store-buttons">
            <a className="store-button google-play">
              <img
                src={googlePlayLogo}
                alt="Google Play"
                className="store-logo"
              />
              <div>
                <span>GET IT ON</span>
                <strong>Google Play</strong>
              </div>
            </a>
            <a className="store-button app-store">
              <img src={appleLogo} alt="App Store" className="store-logo" />
              <div>
                <span>DOWNLOAD ON THE</span>
                <strong>App Store</strong>
              </div>
            </a>
          </div>
        </div>

        {/* Right Image */}
        <div className="download-image-content">
          <img src={phoneMockup} alt="Optimiz app interface on a smartphone" />
        </div>
      </ div>        {/* Left Text */}
      
    </section>
  );
};

export default Downloads;
